<template>
  <div :class="['not-found']">
    <div class="padded-width">
      <h4>This page doesn't exist.</h4>
      <p>
        Thanks for exploring. Feel free to stay around and
        <a href="/" @click.prevent="transitionTo('/')">head back home</a>.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "404",
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    transitionTo(path) {
      this.$router.push(path);
    },
  },
  mounted() {},
};
</script>

<style>
.not-found {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
</style>
